import $ from 'jquery';

window.document.addEventListener('DOMContentLoaded', () => {
  let startAjaxLoading = false;
  // eslint-disable-next-line no-unused-vars
  let isAjaxItemsFound = true;
  let startPaged = 0;
  const ajaxURL = $('#load-more-press').attr('data-ajax-url');
  const pressPages = $('#load-more-press').attr('data-pages');

  $('#load-more-press').on('click', function () {
    const lastItem = $(this).closest('.press').find('.press__card-action').last();
    startPaged++;
    if (!startAjaxLoading) {
      startAjaxLoading = true;
      $('#load-more-press').attr('disabled', true);
      $.ajax({
        type: 'POST',
        url: ajaxURL,
        data: {
          action: 'load_more_press',
          page: startPaged,
        },
        success(response) {
          if (response.content.length > 1) {
            lastItem.focus();
            $('.press__row').append(response.content);
            if (+pressPages > startPaged) {
              $('#load-more-press').attr('disabled', false);
            }
          } else {
            isAjaxItemsFound = false;
          }
          startAjaxLoading = false;
        },
        fail() {
          startAjaxLoading = false;
          isAjaxItemsFound = false;
        },
      });
    }
  });
});
